import './account-selector-modal'
import './account-entries-modal'
import './dependencies-tree'
import './inline-template-editing'
import setupLedgerCopier from './ledger-copier'
import '@app/application/ledger-copier/behaviours/roll-forward-options'
import setupLiquidProfiler from './liquid-profiler'
import setupLiveInputs from './setup-live-inputs'
import './markdown-datepicker'
import './save-changes'
import './starring'
import './template-test-editor'
import './copy-reconciliation-data-modal'
import setupStatusCarousel from './setup-status-carousel'
import setupMarkAsFinalized from './mark-as-finalized'
import setupNavigationCarousel from './setup-navigation-carousel'
import setupTemplateActionsDropdown from './template-actions-dropdown'
import setupInsightsLink from './insights-link'
import setupAutoreconciliationImportRunning from './autoreconciliation-import-running'
import setupExternalCompanySelectorModal from './external-company-selector-modal'

setupStatusCarousel()
setupLiveInputs()
setupMarkAsFinalized()
setupNavigationCarousel()
setupTemplateActionsDropdown()
setupInsightsLink()
setupAutoreconciliationImportRunning()
setupLiquidProfiler()
setupExternalCompanySelectorModal()
setupLedgerCopier()
